export default {"src":"https://assets.ctr1.net/f6d8a33aaf65/_next/static/media/c1-icon-light.9f867260.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};